import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e34e6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-wrap" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = {
  key: 0,
  class: "account-wrap"
}
const _hoisted_4 = { class: "form" }
const _hoisted_5 = {
  key: 1,
  class: "buttons-wrap"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('GOOGLE'))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("JOIN AS A GUEST")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignInAccount = _resolveComponent("SignInAccount")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GuestSignInForm = _resolveComponent("GuestSignInForm")!
  const _component_GuestSignInAccount = _resolveComponent("GuestSignInAccount")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.isAccount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_SignInAccount, {
            userName: _ctx.auth.displayName,
            email: _ctx.auth.email,
            avatar: _ctx.auth.picture
          }, null, 8, ["userName", "email", "avatar"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", _hoisted_4, [
      (_ctx.isAccount)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "button-join",
            type: "primary",
            width: "fill-container",
            onClick: _ctx.joinConf,
            disabled: _ctx.inProgress,
            loading: _ctx.inProgress,
            hideText: _ctx.inProgress
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.textButton), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading", "hideText"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isJoin && !_ctx.showGuestNameInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Button, {
            class: "button-alternative",
            width: "fill-container",
            mode: "outlined",
            disabled: !_ctx.isSignInAvailable,
            loading: _ctx.inProgress,
            hideText: _ctx.inProgress,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.makeGoogleAuth())),
            icon: _ctx.googleButtonIcon
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "loading", "hideText", "icon"]),
          (_ctx.showGuestButton)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "button-alternative",
                width: "fill-container",
                mode: "outlined",
                disabled: !_ctx.isSignInAvailable,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNameInput()))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGuestNameInput)
      ? (_openBlock(), _createBlock(_component_GuestSignInForm, {
          key: 2,
          "in-progress": _ctx.inProgress,
          onSubmit: _ctx.processGuestAuth,
          onClose: _ctx.toggleNameInput
        }, null, 8, ["in-progress", "onSubmit", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isJoin && _ctx.isGuest && _ctx.showGuestButton && !_ctx.showGuestNameInput)
      ? (_openBlock(), _createBlock(_component_GuestSignInAccount, {
          key: 3,
          onSignIn: _ctx.handleSignInExistingGuestSession
        }, null, 8, ["onSignIn"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, null, {
      default: _withCtx(() => [
        _createVNode(_component_Notification, {
          mode: "error",
          title: _ctx.authErrorModalContent.title,
          text: _ctx.authErrorModalContent.description,
          onClose: _ctx.closeModal
        }, null, 8, ["title", "text", "onClose"])
      ]),
      _: 1
    })
  ]))
}